<template lang="pug">
#modal-geral
    el-dialog(
        :width='width',
        :visible='show',
        @close='closeDialog()'
    )
        template(slot='title')
            div.dialog-header
                | {{ title }}
        slot

        el-divider.custom-divider
        .dialog-footer(slot='footer', v-if='mostrarBotaoVoltar && !mostrarBotaoConfirmar')
            BaseButton(type='primary', @click='closeDialog()') {{ $t('mensagens.comuns.fechar') }}
        .dialog-footer-buttons(slot='footer', v-if='mostrarBotaoConfirmar_')
            BaseButton.cancel-button(type='outline', @click='closeDialog()') {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(type='primary', v-if='mostrarBotaoConfirmar_', @click='confirmDialog()') {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'BaseModalGeral',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        title: {
            type: String,
            default: 'Informações',
            required: false
        },
        width: {
            type: String,
            default: '500px'
        },
        mostrarBotaoVoltar: {
            type: Boolean,
            default: true
        },
        mostrarBotaoConfirmar: {
            type: Boolean,
            default: false,
            required: true
        },
        nomeBotaoAcao: {
            type: String,
            default: 'Confirmar'
        }
    },

    watch: {
        mostrarBotaoConfirmar: {
            handler() {
                this.mostrarBotaoConfirmar_ = this.mostrarBotaoConfirmar;
            },
            immediate: true
        }
    },

    data() {
        return {
            mostrarBotaoConfirmar_: false
        };
    },

    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        confirmDialog() {
            this.$emit('confirmDialog');
        }
    }
};
</script>

<style lang="scss">
#modal-geral {
    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .el-dialog__footer {
        margin-top: 0px;
        text-align: right;
    }

    .cancel-button {
        border: 1px solid #00413c !important;
        color: #00413c !important;
    }

    .dialog-footer-buttons {
        margin-top: 0px;
        text-align: right;
        display: flex;
        justify-content: space-between;
    }

    .el-dialog__body {
        max-height: 525px;
        padding: 15px;
    }

    .custom-divider {
        margin-bottom: -5px;
        margin-top: 15px;
    }
}
</style>
